import { useState } from "react";
import { getWeaponImagePath } from "@/lib/utils/weapon-images";
import { cn } from "@/lib/utils";

interface WeaponImageProps {
  textureId?: string;
  alt: string;
  className?: string;
  size?: "small" | "medium" | "large" | "custom";
  showPlaceholder?: boolean;
  disableFilter?: boolean;
}

const sizeClasses = {
  small: "h-5 w-auto",
  medium: "h-[45px] w-auto",
  large: "w-full h-auto max-h-[250px]",
  custom: "",
};

export function WeaponImage({
  textureId,
  alt,
  className,
  size = "medium",
  showPlaceholder = true,
  disableFilter = false,
}: WeaponImageProps) {
  const [imageError, setImageError] = useState(false);

  if (!textureId || imageError) {
    if (!showPlaceholder) {
      return null;
    }
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-muted rounded-lg",
          size === "small" && "h-5 w-5",
          size === "medium" && "h-[45px] w-[45px]",
          size === "large" && "w-full min-h-[200px] max-h-[250px]",
          className
        )}
      >
        <span className="text-xs text-muted-foreground">—</span>
      </div>
    );
  }

  return (
    <img
      src={getWeaponImagePath(textureId)}
      alt={alt}
      className={cn(
        "object-contain",
        size !== "custom" && sizeClasses[size],
        className
      )}
      style={{
        filter: disableFilter ? "none" : "var(--weapon-image-filter)",
        imageRendering: "auto",
      }}
      onError={() => setImageError(true)}
    />
  );
}

